var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56284 0.682843C5.71904 0.526635 5.71904 0.273367 5.56284 0.117159C5.40664 -0.039053 5.15336 -0.039053 4.99716 0.117159L2.84 2.27432L0.682843 0.117159C0.526635 -0.039053 0.273367 -0.039053 0.117159 0.117159C-0.039053 0.273367 -0.039053 0.526635 0.117159 0.682843L2.27432 2.84L0.117159 4.99716C-0.039053 5.15336 -0.039053 5.40664 0.117159 5.56284C0.273367 5.71904 0.526635 5.71904 0.682843 5.56284L2.84 3.40568L4.99716 5.56284C5.15336 5.71904 5.40664 5.71904 5.56284 5.56284C5.71904 5.40664 5.71904 5.15336 5.56284 4.99716L3.40568 2.84L5.56284 0.682843Z",
    fill: "#FF2D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d57c77817c9d1dd17cfeeb2e2a53d63e.svg";
export { ForwardRef as ReactComponent };